import Select from 'react-select';
import { useSmartSelectController } from './SmartSelect.controller';
import type SmartSelectProperties from './SmartSelect.properties.ts';
import { useTranslation } from 'react-i18next';

export default function SmartSelectView(props: SmartSelectProperties) {
  const { t } = useTranslation();
  const { selectedOption, handleChange } = useSmartSelectController(props);

  return (
    <Select
      options={props.data}
      value={selectedOption}
      onChange={handleChange}
      isSearchable
      menuPlacement="auto"
      menuPortalTarget={document.body}
      menuPosition="fixed"
      noOptionsMessage={() => t('ui.noOptionsMessage')}
      styles={{
        container: (base) => ({
          ...base,
          width: props.width ?? '170px',
          marginTop: props.marginTop ?? 0,
          marginBottom: props.marginBottom ?? 0,
        }),
        control: (base, state) => ({
          ...base,
          borderRadius: '10px',
          height: '35px',
          border: state.isFocused ? '1px solid #007bff' : 'none',
          paddingLeft: '15px',
          fontSize: '16px',
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? '#eeeeee' : state.isSelected ? '#dddddd' : '#ffffff',
          color: '#252525',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 100000 }),
      }}
    />
  );
}
